import { Field, FieldProps } from "./Field"
import { CSSFn } from "../styles"
import { Container, StyledInput } from "./styles/InputFieldStyles"
import { InputError } from "../styles/shared"

type InputFieldProps = Omit<FieldProps, "children"> & {
  css?: CSSFn
}

export const InputField = (props: InputFieldProps) => (
  <Field {...props}>
    {({ error, getInputProps }) => (
      <Container>
        <StyledInput {...getInputProps()} />
        {error && <InputError>{error}</InputError>}
      </Container>
    )}
  </Field>
)

InputField.defaultProps = {
  css: undefined,
}
